// extracted by mini-css-extract-plugin
export default {"Heading":"webpack-concepts-Extraction-Blocks-Heading-control-Heading-module__Heading"};